
//import * as $ from "jquery";
import "typescript-collections";
import { Framework } from "../Framework/BaseComponent";
import { Dictionary } from 'typescript-collections';

export module Components {

    var __objectCache: Object = {};
    var __typeCache: Object = {};


    async function loadTypeAsync(jsType: string): Promise<object | null> {

        if (__typeCache.hasOwnProperty(jsType))
            return __typeCache[jsType];

        var type = await import("../" + jsType)
        return __typeCache[jsType] = type;
    }

    function getJSType(element: JQuery): string | null {

        var jsType = element.data("jsType");
        if (jsType && jsType !== "")
            return jsType.replace(/\./ig, "/");

        return null;
    }

    function getTypeByElement(element: JQuery): object | null {

        var jsType = getJSType(element);

        if (jsType == "Common.ScrollPager")
            jsType = "Common.ScrollPager";

        if (!jsType)
            return null;
        if (__typeCache.hasOwnProperty(jsType))
            return __typeCache[jsType];

        return null;
    }

    export function getByElement(element: JQuery): Framework.BaseComponentBase | null {

        var cachekey = element.data("cacheKey");
        if (!cachekey || (cachekey === ""))
            cachekey = getCacheKey(element);

        var currentObject = __objectCache[cachekey]
        if (currentObject)
            return currentObject;

        var type = getTypeByElement(element);
        if (!type)
            return null;

        currentObject = instantiate(element, type, cachekey);
        return <Framework.BaseComponentBase>currentObject;
    }

    export async function initAsync(container?: JQuery, replace?: Boolean): Promise<void> {

        //ES6Promise.polyfill();
        replace = replace || false;

        if (!container)
            container = $("body");


        var components = $(container).find(".component");
        var dict = new Dictionary<string, string>();


        for (var i = 0; i < components.length; i++) {
            var jsType = getJSType(components.eq(i));
            if (!jsType)
                continue;

            if (dict.containsKey(jsType))
                continue;

            dict.setValue(jsType, jsType);

            await loadTypeAsync(jsType)
        }

        for (var i = 0; i < components.length; i++) {
            var element = components.eq(i);
            var jsType = getJSType(components.eq(i));
            var type = getTypeByElement(element);
            if (!type) {
                var jsType = getJSType(element);
                if (!jsType)
                    continue;

                type = await loadTypeAsync(jsType);
            }

            if (type)
                initByElement(element, type, replace);
            else {
                console.error("Could not load type for " + jsType);
                console.error(element);
            }

        }
    }

    function initByElement(element: JQuery, type: any, replace: Boolean): Framework.BaseComponentBase | null {

        if (element.length == 0)
            return null;

        var cachekey = getCacheKey(element);
        var currentObject = replace ? null : __objectCache[cachekey]
        if (currentObject)
            return currentObject;

        currentObject = instantiate(element, type, cachekey, replace);
        return currentObject;
    }

    export function clearObjectCacheByComponent(element: JQuery): void {

        var currentComponent = getByElement(element);
        if (!currentComponent)
            return;

        var cacheKey = getCacheKey(element);

        for (var key in __objectCache)
            if (key.startsWith(cacheKey + "_"))
                __objectCache[key] = null;
    }

    function instantiate(element: JQuery, targetModule: Object, cacheKey: string, replace?: Boolean): Framework.BaseComponentBase | null {

        var jsType: string = element.data("jsType");
        var jsTypeFragments = jsType.split(".");

        var type: any = targetModule;
        for (var i: number = 0; i < jsTypeFragments.length; i++) {
            try {
                type = type[jsTypeFragments[i]];
            } catch (e) {
                var x = e;
            }
        }

        if ($.isFunction(type)) {

            var instance = __objectCache[cacheKey];
            if (replace)
                replace = true;
            if (instance && !replace)
                return instance;

            instance = __objectCache[cacheKey] = new type(element);
            instance.cacheKey = cacheKey;
            return instance;
        }
        else {
            console.warn("Could not find the module type for : " + jsType);
        }

        return null;

    }

    function getCacheKey(element: JQuery): string {

        if (element.data("cacheKey"))
            return element.data("cacheKey");

        var result = getCacheKeyFragment(element);
        var parentComponentList = element.parents(".component");
        $(parentComponentList).each(function () {
            var key = getCacheKeyFragment($(this));
            result = key + "_" + result;
        });

        return result;
    }

    function getCacheKeyFragment(element: JQuery): string {

        if (element.data("cacheKey"))
            return element.data("cacheKey");

        var componentId = element.attr("id");
        var componentType = element.data("js-type");

        var result = componentType + ":" + componentId;

        return result;
    }

    export function clearObjectCacheByContainer(container: JQuery): void {

        var components = container.find(".component");
        components.each((i, e) => {
            var cacheKey = getCacheKey($(e));
            __objectCache[cacheKey] = null;
        });
    }


}